import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';
import toast from 'react-hot-toast';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { createMusica, getFornitori, getArtisti, getGeneriMusica, getCaseDiProduzioneMusica, getCategorieMusica, getSupportiMusica, getUbicazioniMusica, searchDiscogsReleases, getDiscogsReleaseMapped, updateUbicazioniMusica, getCompetitivePrice } from '../services/api';
import { calcolaPrezzoIbs, useImpostazioniPrezzi } from '../utils/prezziIbs';
import { Form, Button, Container, Row, Col, Card, Spinner, Alert, InputGroup } from 'react-bootstrap';
import { debounce } from 'lodash';

const NuovaMusica = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [musica, setMusica] = useState({
        titolo: '',
        artista: '',
        anno: '',
        descrizione: '',
        casa_di_produzione: '',
        categoria: 'MUSICA',
        supporto: '',
        quantita: 1,
        sku: '',
        barcode: '',
        barcode_ibs: '',
        prezzo_negozio: '',
        prezzo_negozio_base: '',
        prezzo_ibs: '',
        costo_acquisto: '',
        iva: 22.0,
        fuori_catalogo: false,
        fornitore_id: null,
        ubicazione: '',
        descrizione_web: '',
        da_pubblicare_su_ibs: true // Nuovo campo, attivo di default
    });
    const [fornitori, setFornitori] = useState([]);
    const [artisti, setArtisti] = useState([]);
    const [generi, setGeneri] = useState([]);
    const [caseDiProduzione, setCaseDiProduzione] = useState([]);
    const [categorie, setCategorie] = useState([]);
    const [supporti, setSupporti] = useState([]);
    const [ubicazioni, setUbicazioni] = useState([]);
    const [ubicazioniRows, setUbicazioniRows] = useState([{ ubicazione: '', quantita: 1 }]); // [{ ubicazione, quantita }]
    const [loading, setLoading] = useState(true); // For loading suggestions
    const [isSaving, setIsSaving] = useState(false); // For submission
    const [error, setError] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

    // State for Discogs Import
    const [discogsSearchTerm, setDiscogsSearchTerm] = useState('');
    const [discogsResults, setDiscogsResults] = useState([]);
    const [showDiscogsResults, setShowDiscogsResults] = useState(false);
    const [isImporting, setIsImporting] = useState(false);
    const { percentualeIbs, markupFissoIbs } = useImpostazioniPrezzi();
    const [isCalcoloPrezzo, setIsCalcoloPrezzo] = useState(false);

    useEffect(() => {
        if (location.state && location.state.barcode) {
            setMusica(prev => ({ ...prev, barcode: location.state.barcode }));
        }
    }, [location.state]);

    const debouncedSearch = React.useRef(
        debounce(async (query) => {
            if (query.length > 2) {
                try {
                    const response = await searchDiscogsReleases(query);
                    setDiscogsResults(response.data);
                    setShowDiscogsResults(true);
                } catch (error) {
                    console.error("Errore nella ricerca Discogs:", error);
                    setError("Errore durante la ricerca su Discogs.");
                }
            } else {
                setShowDiscogsResults(false);
            }
        }, 500)
    ).current;

    useEffect(() => {
        debouncedSearch(discogsSearchTerm);
    }, [discogsSearchTerm, debouncedSearch]);

    useEffect(() => {
        const fetchSuggestions = async () => {
            try {
                const [fornitoriRes, artistiRes, generiRes, caseProdRes, catRes, suppRes, ubicazioniRes] = await Promise.all([
                    getFornitori(),
                    getArtisti(),
                    getGeneriMusica(),
                    getCaseDiProduzioneMusica(),
                    getCategorieMusica(),
                    getSupportiMusica(),
                    getUbicazioniMusica()
                ]);
                setFornitori(fornitoriRes.data.fornitori);
                setArtisti(artistiRes.data);
                setGeneri(generiRes.data);
                setCaseDiProduzione(caseProdRes.data);
                setCategorie(catRes.data);
                setSupporti(suppRes.data);
                setUbicazioni(ubicazioniRes.data);
            } catch (err) {
                console.error("Errore nel caricamento dei suggerimenti:", err);
                setError('Errore nel caricamento dei dati per i menu a tendina.');
            } finally {
                setLoading(false);
            }
        };
        fetchSuggestions();
    }, []);

    useEffect(() => {
        if (selectedImage) {
            setImagePreviewUrl(URL.createObjectURL(selectedImage));
        }
    }, [selectedImage]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newValue = value;

        if (type === 'checkbox') {
            newValue = checked;
        } else if (type === 'number') {
            newValue = value === '' ? null : parseFloat(value);
        } else if (name === 'fornitore_id') {
            newValue = value === '' ? null : parseInt(value);
        } else if (name === 'sku') {
            newValue = value.toUpperCase();
        }

        if (name === 'sku' && newValue === 'MC02') {
            const fornitoreModena = fornitori.find(f => f.denominazione === 'ModenaCinema SAS');
            setMusica(prev => ({
                ...prev,
                sku: newValue,
                costo_acquisto: 0.5,
                fornitore_id: fornitoreModena ? fornitoreModena.id : prev.fornitore_id,
            }));
            setUbicazioniRows(prev => (prev.length === 1 && !prev[0].ubicazione)
                ? [{ ubicazione: 'CD USATI LIB - ANNA', quantita: prev[0].quantita || 1 }]
                : prev);
            return;
        }

        const aggiornamenti = { [name]: newValue };
        if (name === 'prezzo_negozio') {
            // Il prezzo IBS segue sempre il prezzo negozio; il base segue finché non si usa il markup (🚚)
            aggiornamenti.prezzo_ibs = calcolaPrezzoIbs(newValue, percentualeIbs, markupFissoIbs);
            aggiornamenti.prezzo_negozio_base = newValue;
        }
        setMusica({
            ...musica,
            ...aggiornamenti,
        });
    };


    const handleCalcolaPrezzoCompetitivo = async () => {
        const ean = musica.barcode_ibs;
        if (!ean) {
            toast.error('Inserisci prima il Barcode IBS (EAN)');
            return;
        }
        setIsCalcoloPrezzo(true);
        try {
            const res = await getCompetitivePrice(ean, musica.condizione || 'Nuovo', musica.costo_acquisto ? parseFloat(musica.costo_acquisto) : null);
            const { competitive_price, found } = res.data;
            if (found && competitive_price !== null) {
                setMusica(prev => ({ ...prev, prezzo_ibs: competitive_price }));
                toast.success(`Prezzo IBS €${competitive_price.toFixed(2)}: batte ${res.data.concorrente} (${res.data.mercato_totale?.toFixed(2)}€ consegnato)${res.data.battibile === false ? ' — impostato il minimo per il margine' : ''}`);
            } else {
                toast('Nessun prezzo competitor trovato per questo EAN/condizione', { icon: '⚠️' });
            }
        } catch (err) {
            toast.error('Errore nel calcolo del prezzo: ' + (err?.response?.data?.detail || err.message));
        } finally {
            setIsCalcoloPrezzo(false);
        }
    };

    const handleTypeaheadChange = (name, value) => {
        let selectedValue = Array.isArray(value) ? value[0] : value;
        if (typeof selectedValue === 'object' && selectedValue !== null && selectedValue.customOption) {
            selectedValue = selectedValue.label;
        }
        setMusica(prevMusica => ({
            ...prevMusica,
            [name]: selectedValue || '',
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
        }
    };

    const handleImportDiscogs = async (releaseId) => {
        setIsImporting(true);
        setError('');
        try {
            const response = await getDiscogsReleaseMapped(releaseId);
            const importedData = response.data;
            
            // Mappatura esplicita dei campi
            const datiMappati = {
                titolo: importedData.title || '',
                artista: importedData.artists?.map(a => a.name).join(', ') || '',
                anno: importedData.year || '',
                casa_di_produzione: importedData.labels?.[0]?.name || '',
                genere: importedData.genres?.join(', ') || '',
                supporto: importedData.formats?.[0]?.name || '',
                descrizione: importedData.tracklist?.map(t => `${t.position}. ${t.title} (${t.duration})`).join('\n') || '',
            };

            // Prezzo mediano da statistiche marketplace Discogs
            const medianPrice = importedData.marketplace_stats?.median_price?.value
                || importedData.marketplace_stats?.lowest_price?.value
                || null;
            // Il prezzo IBS ora è calcolato dal prezzo negozio: il mediano Discogs resta solo un riferimento
            if (medianPrice !== null) {
                toast(`Prezzo mediano Discogs: €${Number(medianPrice).toFixed(2)} (riferimento)`, { icon: 'ℹ️' });
            }

            // Trova il barcode
            const barcodeIdentifier = importedData.identifiers?.find(id => id.type === 'Barcode');
            if (barcodeIdentifier) {
                datiMappati.barcode = barcodeIdentifier.value;
            }

            setMusica(prev => ({
                ...prev,
                ...datiMappati,
            }));
    
            // Gestione immagine
            const primaryImage = importedData.images?.find(img => img.type === 'primary') || importedData.images?.[0];
            if (primaryImage) {
                setImagePreviewUrl(primaryImage.uri);
                setMusica(prev => ({...prev, immagine_url: primaryImage.uri}));
            }
    
            toast(`Dati pre-compilati da Discogs. Controlla e salva.`);
            setShowDiscogsResults(false);
            setDiscogsSearchTerm('');
        } catch (error) {
            setError(error.response?.data?.detail || "Errore durante il pre-caricamento da Discogs.");
            console.error("Errore importazione Discogs:", error);
        } finally {
            setIsImporting(false);
        }
    };

    const quantitaTotale = ubicazioniRows.reduce((sum, r) => sum + (parseInt(r.quantita) || 0), 0);

    const handleUbicazioneRowChange = (index, field, value) => {
        setUbicazioniRows(prev => prev.map((r, i) => i === index ? { ...r, [field]: field === 'quantita' ? (parseInt(value) || 0) : value } : r));
    };

    const handleAddUbicazioneRow = () => {
        setUbicazioniRows(prev => [...prev, { ubicazione: '', quantita: 0 }]);
    };

    const handleRemoveUbicazioneRow = (index) => {
        setUbicazioniRows(prev => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setError(null);

        try {
            const formDataToSend = new FormData();

            // Includi l'URL dell'immagine nel JSON se non c'è un'immagine locale caricata
            const musicaData = { ...musica };
            if (musicaData.prezzo_negozio_base === '') musicaData.prezzo_negozio_base = null;
            if (!selectedImage && imagePreviewUrl && imagePreviewUrl.startsWith('http')) {
                musicaData.immagine_url = imagePreviewUrl;
            }
            // Quantità e ubicazione sono derivate dalle righe ubicazioni_stock, salvate a parte
            delete musicaData.quantita;
            delete musicaData.ubicazione;

            formDataToSend.append('musica_data', JSON.stringify(musicaData));

            if (selectedImage) {
                formDataToSend.append('immagine_file', selectedImage);
            }

            const response = await createMusica(formDataToSend);

            const righeValide = ubicazioniRows
                .map(r => ({ ubicazione: (r.ubicazione || '').trim(), quantita: parseInt(r.quantita) || 0 }))
                .filter(r => r.ubicazione && r.quantita > 0);
            if (righeValide.length > 0) {
                await updateUbicazioniMusica(response.data.musica.id, righeValide);
            }

            toast.success('Nuovo album salvato con successo!');
            // Se la creazione arriva dall'inventario, torna all'inventario passando il nuovo prodotto
            if (location.state?.from === 'inventory') {
                navigate('/magazzino/inventario', { state: { newProduct: response.data, wasScanning: location.state.wasScanning }});
            } else {
                navigate('/musica');
            }
        } catch (error) {
            console.error("Errore nella creazione del nuovo album:", error);
            const errorMessage = error.response?.data?.detail ? JSON.stringify(error.response.data.detail) : "Errore durante il salvataggio.";
            setError(errorMessage);
        } finally {
            setIsSaving(false);
        }
    };

    if (loading) {
        return <Spinner animation="border" />;
    }

    return (
        <Container>
            <div className="sticky-action-bar">
                <Row className="align-items-center">
                    <Col>
                        <h2>Nuovo Album</h2>
                    </Col>
                    <Col className="text-end">
                        <Button variant="secondary" onClick={() => navigate('/musica')} className="me-2">
                            Annulla
                        </Button>
                        <Button variant="primary" onClick={handleSubmit} disabled={isSaving}>
                            {isSaving ? <Spinner as="span" animation="border" size="sm" /> : 'Salva Nuovo Album'}
                        </Button>
                    </Col>
                </Row>
            </div>

            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

            <Form onSubmit={(e) => e.preventDefault()}>

                <Card className="mb-3">
                    <Card.Header>Codici</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={4}><Form.Group className="mb-3"><Form.Label>SKU</Form.Label><Form.Control type="text" name="sku" value={musica.sku} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group className="mb-3"><Form.Label>Barcode</Form.Label><Form.Control type="text" name="barcode" value={musica.barcode} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group className="mb-3"><Form.Label>Barcode IBS</Form.Label><Form.Control type="text" name="barcode_ibs" value={musica.barcode_ibs} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Card className="mb-3">
                    <Card.Header>Importa Dati da Discogs</Card.Header>
                    <Card.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Cerca su Discogs</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Cerca per artista, album, barcode..."
                                    value={discogsSearchTerm}
                                    onChange={(e) => setDiscogsSearchTerm(e.target.value)}
                                />
                            </InputGroup>
                            {showDiscogsResults && (
                                <div className="list-group" style={{ zIndex: 1000, position: 'absolute', width: '90%' }}>
                                    {discogsResults.map(release => (
                                        <div key={release.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                                            <div>
                                                <img src={release.thumb} alt="cover" style={{width: '40px', height: '40px', marginRight: '10px'}} />
                                                {release.title} ({release.year})
                                            </div>
                                            <Button
                                                variant="success"
                                                size="sm"
                                                onClick={() => handleImportDiscogs(release.id)}
                                                disabled={isImporting}
                                            >
                                                {isImporting ? <Spinner size="sm" /> : 'Pre-compila'}
                                            </Button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Form.Group>
                    </Card.Body>
                </Card>

                <Card className="mb-3">
                    <Card.Header>Informazioni Principali</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Titolo Album</Form.Label><Form.Control type="text" name="titolo" value={musica.titolo} onChange={handleChange} required /></Form.Group></Col>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Anno</Form.Label><Form.Control type="number" name="anno" value={musica.anno} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Artista</Form.Label><Typeahead id="artista-typeahead" options={artisti} allowNew onChange={(s) => handleTypeaheadChange('artista', s)} onInputChange={(t) => handleTypeaheadChange('artista', t)} selected={musica.artista ? [musica.artista] : []} placeholder="Seleziona o inserisci un artista" /></Form.Group></Col>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Genere</Form.Label><Typeahead id="genere-typeahead" options={generi} allowNew onChange={(s) => handleTypeaheadChange('genere', s)} onInputChange={(t) => handleTypeaheadChange('genere', t)} selected={musica.genere ? [musica.genere] : []} placeholder="Seleziona o inserisci un genere" /></Form.Group></Col>
                        </Row>
                        <Form.Group className="mb-3"><Form.Label>Descrizione</Form.Label><Form.Control as="textarea" rows={3} name="descrizione" value={musica.descrizione} onChange={handleChange} /></Form.Group>
                    </Card.Body>
                </Card>

                <Card className="mb-3">
                    <Card.Header>Dettagli Prodotto</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Casa di Produzione</Form.Label><Typeahead id="casa-di-produzione-typeahead" options={caseDiProduzione} allowNew onChange={(s) => handleTypeaheadChange('casa_di_produzione', s)} onInputChange={(t) => handleTypeaheadChange('casa_di_produzione', t)} selected={musica.casa_di_produzione ? [musica.casa_di_produzione] : []} placeholder="Seleziona o inserisci una casa di produzione" /></Form.Group></Col>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Categoria</Form.Label><Typeahead id="categoria-typeahead" options={categorie} allowNew onChange={(s) => handleTypeaheadChange('categoria', s)} onInputChange={(t) => handleTypeaheadChange('categoria', t)} selected={musica.categoria ? [musica.categoria] : []} placeholder="Seleziona o inserisci una categoria" /></Form.Group></Col>
                        </Row>
                        <Row>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Supporto</Form.Label><Typeahead id="supporto-typeahead" options={supporti} allowNew onChange={(s) => handleTypeaheadChange('supporto', s)} onInputChange={(t) => handleTypeaheadChange('supporto', t)} selected={musica.supporto ? [musica.supporto] : []} placeholder="Seleziona o inserisci un supporto" /></Form.Group></Col>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Quantità <span className="text-muted fw-normal small">(somma delle ubicazioni sotto)</span></Form.Label><Form.Control type="number" value={quantitaTotale} readOnly disabled /></Form.Group></Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Card className="mb-3">
                    <Card.Header>Prezzi</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={3}><Form.Group className="mb-3"><Form.Label>Prezzo Negozio</Form.Label><InputGroup><Form.Control type="number" step="0.01" name="prezzo_negozio" value={musica.prezzo_negozio ?? ''} onChange={handleChange} /></InputGroup>{musica.prezzo_negozio_base !== '' && musica.prezzo_negozio_base != null && (<Form.Text className="text-muted">Prezzo base: €{Number(musica.prezzo_negozio_base).toFixed(2)}</Form.Text>)}</Form.Group></Col>
                            <Col md={3}><Form.Group className="mb-3"><Form.Label>Prezzo IBS <span className="text-muted small">(dal prezzo base: +{percentualeIbs}% +{markupFissoIbs}€)</span></Form.Label><InputGroup><Form.Control type="number" step="0.01" name="prezzo_ibs" value={musica.prezzo_ibs ?? ''} disabled readOnly /><Button variant="outline-secondary" onClick={handleCalcolaPrezzoCompetitivo} disabled={isCalcoloPrezzo || !musica.barcode_ibs} title="Sovrascrivi con il prezzo competitivo da IBS Marketplace (P11)">{isCalcoloPrezzo ? <Spinner as="span" animation="border" size="sm" /> : '💰 P11'}</Button></InputGroup></Form.Group></Col>
                            <Col md={3}><Form.Group className="mb-3"><Form.Label>Costo Acquisto</Form.Label><Form.Control type="number" step="0.01" name="costo_acquisto" value={musica.costo_acquisto} onChange={handleChange} /></Form.Group></Col>
                            <Col md={3}><Form.Group className="mb-3"><Form.Label>IVA (%)</Form.Label><Form.Control type="number" step="0.01" name="iva" value={musica.iva} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Card className="mb-3">
                    <Card.Header>Immagine Musica</Card.Header>
                    <Card.Body>
                        <Row className="align-items-center">
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Carica Immagine Locale</Form.Label><Form.Control type="file" onChange={handleFileChange} /></Form.Group></Col>
                            <Col md={6}>{imagePreviewUrl && (<div className="mt-3"><p>Anteprima Immagine:</p><img src={imagePreviewUrl} alt={musica.titolo} style={{ maxWidth: '200px', height: 'auto' }} className="img-thumbnail" /></div>)}</Col>
                        </Row>
                        <Alert variant="info">Se non carichi un'immagine locale, il sistema proverà a scaricare quella da Discogs (se disponibile) dopo aver salvato.</Alert>
                    </Card.Body>
                </Card>
                
                <Card className="mb-3">
                    <Card.Header>Fornitore e Catalogo</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Fornitore</Form.Label><Form.Select name="fornitore_id" value={musica.fornitore_id || ''} onChange={handleChange}><option value="">Seleziona fornitore</option>{fornitori.map(f => <option key={f.id} value={f.id}>{f.denominazione}</option>)}</Form.Select></Form.Group></Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Ubicazioni <span className="text-muted fw-normal small">(una riga per ogni locazione fisica)</span></Form.Label>
                                    {ubicazioniRows.map((riga, index) => (
                                        <InputGroup className="mb-2" key={index}>
                                            <Form.Control
                                                type="text"
                                                value={riga.ubicazione}
                                                onChange={(e) => handleUbicazioneRowChange(index, 'ubicazione', e.target.value)}
                                                list="ubicazioni-musica-list"
                                                placeholder="Ubicazione"
                                            />
                                            <Form.Control
                                                type="number"
                                                min="0"
                                                value={riga.quantita}
                                                onChange={(e) => handleUbicazioneRowChange(index, 'quantita', e.target.value)}
                                                style={{ maxWidth: 100 }}
                                                placeholder="Qtà"
                                            />
                                            <Button variant="outline-danger" onClick={() => handleRemoveUbicazioneRow(index)}>&times;</Button>
                                        </InputGroup>
                                    ))}
                                    <datalist id="ubicazioni-musica-list">{ubicazioni.map(u => <option key={u} value={u} />)}</datalist>
                                    <Button variant="outline-secondary" size="sm" onClick={handleAddUbicazioneRow}>+ Aggiungi ubicazione</Button>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Check type="switch" name="fuori_catalogo" label="Fuori Catalogo" checked={musica.fuori_catalogo} onChange={handleChange} className="d-inline-block me-3" />
                            <Form.Check type="switch" name="da_pubblicare_su_ibs" label="Presente su IBS" checked={musica.da_pubblicare_su_ibs} onChange={handleChange} className="d-inline-block" />
                        </Form.Group>
                    </Card.Body>
                </Card>

            </Form>
        </Container>
    );
};

export default NuovaMusica;